// Copyright Epic Games, Inc. All Rights Reserved.
import useSWRImmutable from 'swr/immutable';

import { useUserContext } from '@contexts/User';
import { postAPIFetcher } from '@isomorphic/swr-fetchers';
import { APP_BASE_PATH } from '@constants/app';
import type { LocalesUnion } from '@constants/i18n';

// Shared protected-content fetch used by both gating wrappers. Keying on
// accountId ensures a logout-without-reload invalidates the SWR cache entry and
// the (stale) protected content is not re-rendered for the now-anonymous session.
export const useProtectedContentQuery = (slug: string[], locale: LocalesUnion) => {
  const account = useUserContext();
  const accountKey = account?.id ?? 'anon';

  return useSWRImmutable(
    {
      url: `/${APP_BASE_PATH}/api/protected-content`,
      body: { slug, locale },
      key: `${accountKey}:${slug.join('/')}`,
    },
    postAPIFetcher
  );
};
